import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
    faFacebookSquare,
    faGithubSquare,
    faInstagramSquare,
    faLinkedin,
    faPiedPiperSquare,
    faPinterestSquare,
    faSnapchatSquare,
    faTiktok,
    faTwitterSquare,
    faWhatsappSquare,
    faYoutubeSquare,
} from '@fortawesome/free-brands-svg-icons';

const getIcon = (platform) => {
    switch (platform) {
        case 'facebook':
            return faFacebookSquare;
        case 'github':
            return faGithubSquare;
        case 'instagram':
            return faInstagramSquare;
        case 'linkedIn':
            return faLinkedin;
        case 'pinterest':
            return faPinterestSquare;
        case 'twitter':
            return faTwitterSquare;
        case 'youTube':
            return faYoutubeSquare;
        case 'whatsApp':
            return faWhatsappSquare;
        case 'tikTok':
            return faTiktok;
        case 'snapchat':
            return faSnapchatSquare;
        default:
            return faPiedPiperSquare;
    }
};

const SocialAccount = (props) => {
    const { socialPlatformKey: platform, socialAccountDisplayName: name, socialAccountUrl: link } = props.socialAccount;
    const icon = getIcon(platform);

    return (
        <a href={link} target="_blank" rel="noreferrer" title={name}
            style={{
                display: 'block',
                marginBottom: 3,
            }}>
            <FontAwesomeIcon icon={icon} fontSize={'1.5rem'} style={{
                color: 'gray',
                marginRight: 5,
            }} />
        </a>
    );
};

export default SocialAccount;